/* ============================================================================
   ALIA · Saint-Jacques — ALL theme behaviour, one file.

   Extracted verbatim from the three inline <script> blocks that used to sit at
   the foot of templates/index.liquid. Nothing here changed except its address.

   WHY ONE FILE, AND WHY DEFERRED (master prompt §4 rule 2, traps 18 & 20):
     · Inline <script src> without defer is a ParserBlockingScript ERROR. Those
       four errors were previously hidden by a {% comment %}theme-check-disable
       {% endcomment %} on line 1 of index.liquid — a clean theme check that was
       not actually clean.
     · defer PRESERVES DOCUMENT ORDER, so gsap → ScrollTrigger → SplitText →
       lenis → this file still execute in exactly that sequence, and this file
       still runs after the document is parsed. That is the identical condition
       an inline end-of-body script had, which is why the choreography is
       unaffected.
     · The choreography is orchestrated globally — ONE Lenis instance and ONE
       ScrollTrigger set. Never fragment this per-section.

   The three original blocks are marked below in the order they appeared.
   ========================================================================== */

/* ===== 1/3 · main bundle: preloader, cursor, reveals, set pieces, lightbox, FAQ, footer ===== */
(function(){
  "use strict";
  var doc=document, root=doc.documentElement, body=doc.body;
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var finePointer = window.matchMedia && window.matchMedia("(hover:hover) and (pointer:fine)").matches;
  if(reduced) root.classList.add("reduced");
  var hasGSAP = !!window.gsap;
  if(!hasGSAP) root.classList.add("no-gsap");
  var ST = window.ScrollTrigger || null;
  var clamp=function(v,a,b){return v<a?a:(v>b?b:v);};
  var lerp=function(a,b,t){return a+(b-a)*t;};
  var mapr=function(v,a,b,c,d){return c+(d-c)*clamp((v-a)/(b-a),0,1);};
  var qs=function(s,c){return (c||doc).querySelector(s);};
  var qsa=function(s,c){return Array.prototype.slice.call((c||doc).querySelectorAll(s));};

  /* ---------------- PRELOADER (<= 2.5s) ---------------- */
  function runPreloader(done){
    var pre=qs("#pre"), num=qs("#preNum"), bar=qs("#preBar"),
        spans=qsa("#preMark span"), arc=qs("#preArc");
    if(!pre){ done(); return; }
    if(reduced || !hasGSAP){
      if(num) num.textContent="100";
      pre.classList.add("done");
      setTimeout(function(){ if(pre.parentNode) pre.parentNode.removeChild(pre); },300);
      done(); return;
    }
    if(arc){ try{ var L=arc.getTotalLength(); arc.style.strokeDasharray=L; arc.style.strokeDashoffset=L; }catch(e){} }
    var tl=gsap.timeline({onComplete:function(){
      pre.classList.add("done");
      setTimeout(function(){ if(pre.parentNode) pre.parentNode.removeChild(pre); },720);
      done();
    }});
    tl.fromTo(spans,{yPercent:120,opacity:0},{yPercent:0,opacity:1,duration:.6,stagger:.08,ease:"power4.out"},0);
    var c={v:0};
    tl.to(c,{v:100,duration:1.35,ease:"power2.inOut",onUpdate:function(){
      var val=Math.round(c.v);
      if(num) num.textContent=(val<10?"0":"")+val;
      if(bar) bar.style.transform="scaleX("+(c.v/100)+")";
      if(arc){ try{ arc.style.strokeDashoffset=arc.getTotalLength()*(1-c.v/100); }catch(e){} }
    }},.1);
    tl.to({},{duration:.12});
  }

  /* ---------------- CURSOR + MAGNETIC ---------------- */
  function initCursor(){
    if(!finePointer || reduced || !hasGSAP) return;
    root.classList.add("has-cursor");
    var dot=qs(".cur-dot"), ring=qs(".cur-ring");
    if(!dot||!ring) return;
    var mx=innerWidth/2,my=innerHeight/2,rx=mx,ry=my;
    var xd=gsap.quickSetter(dot,"x","px"),yd=gsap.quickSetter(dot,"y","px");
    var xr=gsap.quickSetter(ring,"x","px"),yr=gsap.quickSetter(ring,"y","px");
    window.addEventListener("mousemove",function(e){mx=e.clientX;my=e.clientY;},{passive:true});
    gsap.ticker.add(function(){
      xd(mx);yd(my);
      rx=lerp(rx,mx,.2);ry=lerp(ry,my,.2);
      xr(rx);yr(ry);
    });
    qsa("a, button, [data-cursor]").forEach(function(el){
      el.addEventListener("mouseenter",function(){ring.classList.add("on");});
      el.addEventListener("mouseleave",function(){ring.classList.remove("on");});
    });
    qsa("[data-mag]").forEach(function(el){
      var qx=gsap.quickTo(el,"x",{duration:.5,ease:"power3"});
      var qy=gsap.quickTo(el,"y",{duration:.5,ease:"power3"});
      el.addEventListener("mousemove",function(e){
        var r=el.getBoundingClientRect();
        qx((e.clientX-(r.left+r.width/2))*.28);
        qy((e.clientY-(r.top+r.height/2))*.4);
      });
      el.addEventListener("mouseleave",function(){qx(0);qy(0);});
    });
  }

  /* ---------------- NAV + PROGRESS ---------------- */
  var nav=qs("#nav"), progress=qs("#progress");
  function onScroll(){
    var y=window.pageYOffset||doc.documentElement.scrollTop||0;
    if(nav){ if(y>50) nav.classList.add("scrolled"); else nav.classList.remove("scrolled"); }
    if(progress){
      var h=doc.documentElement.scrollHeight-window.innerHeight;
      var p=h>0?clamp(y/h,0,1):0;
      progress.style.transform="scaleX("+p+")";
    }
  }

  /* ---------------- REVEALS ---------------- */
  function initReveals(){
    qsa("[data-headline]").forEach(function(el){
      if(window.SplitText){
        try{
          var sp=new SplitText(el,{type:"lines"});
          sp.lines.forEach(function(l){
            var m=doc.createElement("span"); m.className="ln-mask";
            l.parentNode.insertBefore(m,l); m.appendChild(l);
          });
          gsap.set(sp.lines,{yPercent:118});
          ST.create({trigger:el,start:"top 85%",once:true,onEnter:function(){
            gsap.to(sp.lines,{yPercent:0,duration:1.05,ease:"power4.out",stagger:.09});
          }});
          return;
        }catch(e){}
      }
      gsap.set(el,{opacity:0,y:34});
      ST.create({trigger:el,start:"top 85%",once:true,onEnter:function(){
        gsap.to(el,{opacity:1,y:0,duration:1,ease:"expo.out"});
      }});
    });
    var items=qsa("[data-reveal]");
    gsap.set(items,{opacity:0,y:28});
    ST.batch(items,{start:"top 90%",onEnter:function(b){
      gsap.to(b,{opacity:1,y:0,duration:.9,ease:"expo.out",stagger:.07,overwrite:true});
    }});
  }

  /* ---------------- SET PIECE 1 : THE WAY THERE ---------------- */
  var wayRender=null;
  function initWayThere(){
    var route=qs("#wayRoute"), mover=qs("#wayMover"), wps=qs("#wayWps"),
        list=qs("#wayList"), addr=qs("#wayAddr"), mkRing=qs("#wayMkRing"),
        roKm=qs("#roKm"), roEta=qs("#roEta");
    if(!route) return;
    var len=1;
    try{ len=route.getTotalLength(); }catch(e){}
    // address letters
    var addrText="997 RUE SAINT-JACQUES";
    if(addr){
      addr.innerHTML="";
      addrText.split("").forEach(function(ch){
        var s=doc.createElement("span");
        if(ch===" "){ s.className="sp"; } else { s.className="ch"; s.textContent=ch; }
        addr.appendChild(s);
      });
    }
    var chars=qsa(".ch",addr);
    var liRows=qsa("li",list);
    var fracs=liRows.map(function(li){ return parseFloat(li.getAttribute("data-frac"))||0; });
    // place waypoint dots on the path
    if(wps){
      wps.innerHTML="";
      fracs.forEach(function(f){
        var pt={x:120,y:610};
        try{ pt=route.getPointAtLength(len*f); }catch(e){}
        var c=doc.createElementNS("http://www.w3.org/2000/svg","circle");
        c.setAttribute("class","wm-wp");
        c.setAttribute("cx",pt.x); c.setAttribute("cy",pt.y); c.setAttribute("r","6");
        wps.appendChild(c);
      });
    }
    var wpDots=qsa(".wm-wp",wps);
    var TOTAL_KM=2.9, TOTAL_MIN=11;

    wayRender=function(p){
      p=clamp(p,0,1);
      // draw route
      route.style.strokeDasharray=len;
      route.style.strokeDashoffset=len*(1-p);
      // mover
      var pt;
      try{ pt=route.getPointAtLength(len*p); }catch(e){ pt=null; }
      if(pt && mover){ mover.setAttribute("cx",pt.x); mover.setAttribute("cy",pt.y); }
      // waypoints + list
      for(var i=0;i<fracs.length;i++){
        var lit = p>=fracs[i]-0.001;
        if(wpDots[i]){ wpDots[i].classList.toggle("lit",lit); }
        if(liRows[i]){ liRows[i].classList.toggle("lit",lit); liRows[i].classList.remove("active"); }
      }
      // active = last lit
      var last=-1;
      for(var j=0;j<fracs.length;j++){ if(p>=fracs[j]-0.001) last=j; }
      if(last>=0 && liRows[last]) liRows[last].classList.add("active");
      // readouts
      if(roKm) roKm.textContent=(TOTAL_KM*(1-p)).toFixed(1);
      if(roEta) roEta.textContent=Math.max(0,Math.round(TOTAL_MIN*(1-p)));
      // marker pulse scale
      if(mkRing){ var r=16+Math.sin(Date.now()/400)*0; mkRing.setAttribute("r", (14+6*p).toFixed(1)); }
      // address letters
      var shown=Math.round(mapr(p,0.62,1,0,chars.length));
      for(var k=0;k<chars.length;k++){ chars[k].classList.toggle("on", k<shown); }
    };

    if(reduced || !hasGSAP || !ST){ wayRender(1); return; }

    var mm=gsap.matchMedia();
    mm.add("(min-width:920px)",function(){
      var proxy={p:0};
      var tw=gsap.to(proxy,{p:1,ease:"none",onUpdate:function(){ wayRender(proxy.p); },
        scrollTrigger:{trigger:"#way",start:"top top",end:"+=1900",scrub:.7,pin:".way-inner",anticipatePin:1}});
      wayRender(0);
      return function(){ /* matchMedia auto-reverts; ensure static */ wayRender(1); };
    });
    mm.add("(max-width:919px)",function(){
      var proxy={p:0};
      var tw=gsap.to(proxy,{p:1,ease:"none",onUpdate:function(){ wayRender(proxy.p); },
        scrollTrigger:{trigger:"#way",start:"top 78%",end:"bottom 60%",scrub:.6}});
      return function(){ wayRender(1); };
    });
  }

  /* ---------------- SET PIECE 2 : BILINGUAL ---------------- */
  function initBilingual(){
    var rows=qsa(".bl-row"), langInd=qs("#blLang");
    if(!rows.length) return;
    if(reduced || !hasGSAP){ return; } // FR shows statically
    var timers=[];
    var states=rows.map(function(){ return true; }); // true = FR showing
    function swap(i){
      var row=rows[i]; if(!row) return;
      var fr=qs(".bl-fr",row), en=qs(".bl-en",row);
      var showingFr=states[i];
      var outEl=showingFr?fr:en, inEl=showingFr?en:fr;
      gsap.to(outEl,{autoAlpha:0,yPercent:-16,duration:.6,ease:"power3.inOut"});
      gsap.fromTo(inEl,{autoAlpha:0,yPercent:16},{autoAlpha:1,yPercent:0,duration:.6,ease:"power3.inOut"});
      states[i]=!showingFr;
    }
    var running=false;
    function start(){
      if(running) return; running=true;
      rows.forEach(function(row,i){
        timers[i]=setInterval(function(){ swap(i); },2500+i*280);
      });
      if(langInd){
        timers.push(setInterval(function(){
          langInd.textContent = langInd.textContent==="FR"?"EN":"FR";
        },2500));
      }
    }
    function stop(){
      running=false;
      timers.forEach(function(t){ clearInterval(t); });
      timers=[];
    }
    if("IntersectionObserver" in window){
      var io=new IntersectionObserver(function(ents){
        ents.forEach(function(en){ if(en.isIntersecting) start(); else stop(); });
      },{threshold:.2});
      io.observe(qs("#biling"));
    } else { start(); }
  }

  /* ---------------- FIRE CANVAS (embers) ---------------- */
  function initFireCanvas(){
    var cv=qs("#fireCanvas");
    if(!cv || reduced) return;
    var ctx=cv.getContext("2d");
    if(!ctx) return;
    var DPR=Math.min(window.devicePixelRatio||1,2);
    var W=0,H=0,parts=[],raf=null,active=false;
    function size(){
      var r=cv.getBoundingClientRect();
      cv.width=Math.max(1,Math.round(r.width*DPR));
      cv.height=Math.max(1,Math.round(r.height*DPR));
      W=cv.width; H=cv.height;
    }
    function seed(){
      parts=[];
      var n=Math.round((W*H)/26000);
      n=clamp(n,26,90);
      for(var i=0;i<n;i++){ parts.push(mk(true)); }
    }
    function mk(init){
      return {
        x:Math.random()*W,
        y:init?Math.random()*H:H+Math.random()*40*DPR,
        r:(Math.random()*1.7+0.6)*DPR,
        vy:(Math.random()*0.5+0.25)*DPR,
        vx:(Math.random()-0.5)*0.35*DPR,
        a:Math.random()*0.5+0.25,
        tw:Math.random()*Math.PI*2
      };
    }
    function frame(){
      if(!active) return;
      ctx.clearRect(0,0,W,H);
      ctx.globalCompositeOperation="lighter";
      for(var i=0;i<parts.length;i++){
        var p=parts[i];
        p.y-=p.vy; p.x+=p.vx; p.tw+=0.05;
        if(p.y< -10*DPR){ parts[i]=mk(false); continue; }
        var fl=0.6+Math.sin(p.tw)*0.4;
        var g=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,p.r*4);
        g.addColorStop(0,"rgba(138,95,58,"+(p.a*fl).toFixed(3)+")");
        g.addColorStop(1,"rgba(138,95,58,0)");
        ctx.fillStyle=g;
        ctx.beginPath(); ctx.arc(p.x,p.y,p.r*4,0,Math.PI*2); ctx.fill();
        ctx.fillStyle="rgba(238,237,227,"+(p.a*fl*0.5).toFixed(3)+")";
        ctx.beginPath(); ctx.arc(p.x,p.y,p.r*0.6,0,Math.PI*2); ctx.fill();
      }
      ctx.globalCompositeOperation="source-over";
      raf=requestAnimationFrame(frame);
    }
    function play(){ if(active) return; active=true; frame(); }
    function pause(){ active=false; if(raf) cancelAnimationFrame(raf); }
    size(); seed();
    var rt;
    window.addEventListener("resize",function(){ clearTimeout(rt); rt=setTimeout(function(){ size(); seed(); },200); });
    if("IntersectionObserver" in window){
      var io=new IntersectionObserver(function(ents){
        ents.forEach(function(en){ if(en.isIntersecting) play(); else pause(); });
      },{threshold:.05});
      io.observe(cv);
    } else { play(); }
  }

  /* ---------------- GALLERY LIGHTBOX ----------------
     §5: bind by DELEGATION on document and build the overlay ONCE, appended
     to <body>. Inside the section it would be clipped by overflow:hidden and
     trapped in that section's stacking context. Only cells that actually hold
     a photo carry [data-lbx], so only those are clickable. */
  function initLightbox(){
    var cells=qsa(".gal-cell[data-lbx]");
    if(!cells.length) return;

    var shots=cells.map(function(c){ return c.getAttribute("data-lbx"); });
    var idx=0, box=null, img=null, cnt=null, lastFocus=null;

    function build(){
      if(box) return;
      box=doc.createElement("div");
      box.className="lbx";
      box.setAttribute("role","dialog");
      box.setAttribute("aria-modal","true");
      box.setAttribute("aria-label","Gallery");
      box.innerHTML=
        '<button type="button" class="lbx-close" aria-label="Close">&#10005;</button>'+
        '<button type="button" class="lbx-prev" aria-label="Previous">&#8249;</button>'+
        '<img alt="">'+
        '<button type="button" class="lbx-next" aria-label="Next">&#8250;</button>'+
        '<span class="lbx-cnt"></span>';
      doc.body.appendChild(box);
      img=qs("img",box);
      cnt=qs(".lbx-cnt",box);
      box.addEventListener("click",function(e){
        if(e.target===box){ close(); return; }
        if(e.target.closest(".lbx-close")){ close(); return; }
        if(e.target.closest(".lbx-prev")){ step(-1); return; }
        if(e.target.closest(".lbx-next")){ step(1); }
      });
    }

    function paint(){
      img.src=shots[idx];
      img.alt="ALIA Saint-Jacques, corporate photo "+(idx+1)+" of "+shots.length;
      cnt.textContent=(idx+1)+" / "+shots.length;
    }
    function step(d){ idx=(idx+d+shots.length)%shots.length; paint(); }

    function open(i){
      build();
      lastFocus=doc.activeElement;
      idx=i; paint();
      box.classList.add("on");
      body.classList.add("locked");
      if(window.__aliaLenis && window.__aliaLenis.stop){ try{ window.__aliaLenis.stop(); }catch(e){} }
      qs(".lbx-close",box).focus();
    }
    function close(){
      if(!box) return;
      box.classList.remove("on");
      body.classList.remove("locked");
      if(window.__aliaLenis && window.__aliaLenis.start){ try{ window.__aliaLenis.start(); }catch(e){} }
      if(lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* delegation on document — one listener, survives any DOM swap */
    doc.addEventListener("click",function(e){
      var cell=e.target.closest && e.target.closest(".gal-cell[data-lbx]");
      if(!cell) return;
      var i=cells.indexOf(cell);
      if(i>-1) open(i);
    });
    doc.addEventListener("keydown",function(e){
      var cell=e.target.closest && e.target.closest(".gal-cell[data-lbx]");
      if(cell && (e.key==="Enter"||e.key===" ")){
        e.preventDefault();
        var i=cells.indexOf(cell);
        if(i>-1) open(i);
        return;
      }
      if(!box || !box.classList.contains("on")) return;
      if(e.key==="Escape") close();
      else if(e.key==="ArrowLeft") step(-1);
      else if(e.key==="ArrowRight") step(1);
    });
  }

  /* ---------------- FAQ ---------------- */
  function initFAQ(){
    qsa(".faq-item").forEach(function(item){
      var q=qs(".faq-q",item), a=qs(".faq-a",item), inner=qs(".inner",item);
      if(!q||!a) return;
      q.addEventListener("click",function(){
        var open=item.classList.contains("open");
        qsa(".faq-item.open").forEach(function(o){
          if(o!==item){ o.classList.remove("open"); var oa=qs(".faq-a",o);
            if(hasGSAP) gsap.to(oa,{height:0,duration:.45,ease:"power3.inOut"}); else oa.style.height="0px"; }
        });
        if(open){
          item.classList.remove("open");
          if(hasGSAP) gsap.to(a,{height:0,duration:.45,ease:"power3.inOut"}); else a.style.height="0px";
        } else {
          item.classList.add("open");
          var target=inner.offsetHeight;
          if(hasGSAP) gsap.fromTo(a,{height:a.offsetHeight},{height:target,duration:.5,ease:"power3.inOut",onComplete:function(){ a.style.height="auto"; }});
          else a.style.height=target+"px";
        }
      });
    });
  }

  /* ---------------- FOOTER wordmark ---------------- */
  function initFooter(){
    var fw=qs("#footWord");
    if(!fw) return;
    var letters="ALIA".split("");
    fw.innerHTML="";
    letters.forEach(function(ch){
      var s=doc.createElement("span"); s.className="fl"; s.textContent=ch; s.setAttribute("data-cursor","");
      fw.appendChild(s);
    });
    var fls=qsa(".fl",fw);
    if(reduced || !hasGSAP || !ST){ fls.forEach(function(f){ f.classList.add("lit"); }); return; }
    ST.create({trigger:fw,start:"top 80%",once:true,onEnter:function(){
      fls.forEach(function(f,i){ setTimeout(function(){ f.classList.add("lit"); }, i*140); });
    }});
    fls.forEach(function(f){
      f.addEventListener("mouseenter",function(){ if(hasGSAP) gsap.fromTo(f,{y:0},{y:-8,duration:.3,yoyo:true,repeat:1,ease:"power2.out"}); });
    });
  }

  /* ---------------- EASTER EGG ---------------- */
  function initEaster(){
    var toast=qs("#toast");
    var hero=qs(".hero h1");
    function flare(){
      if(toast && hasGSAP && !reduced){
        gsap.killTweensOf(toast);
        gsap.fromTo(toast,{opacity:0,y:20},{opacity:1,y:0,duration:.45,ease:"power3.out"});
        gsap.to(toast,{opacity:0,y:20,duration:.5,delay:2.2,ease:"power3.in"});
      }
      var glow=qs(".hero-glow");
      if(glow && hasGSAP && !reduced){ gsap.fromTo(glow,{scale:1,opacity:1},{scale:1.25,opacity:.6,duration:.7,yoyo:true,repeat:1,ease:"power2.inOut"}); }
    }
    if(hero){ hero.addEventListener("dblclick",flare); }
  }

  /* ---------------- BOOT ---------------- */
  function boot(){
    initCursor();
    initFAQ();
    initEaster();
    initLightbox();

    var lenis=null;
    if(window.Lenis && !reduced){
      try{
        lenis=new Lenis({duration:1.1,smoothWheel:true,wheelMultiplier:1,touchMultiplier:1.5});
        if(hasGSAP && ST){
          lenis.on("scroll",function(){ ST.update(); onScroll(); });
          gsap.ticker.add(function(t){ lenis.raf(t*1000); });
          gsap.ticker.lagSmoothing(0);
        } else {
          var raf=function(t){ lenis.raf(t); requestAnimationFrame(raf); }; requestAnimationFrame(raf);
        }
      }catch(e){ lenis=null; }
    }
    if(!lenis){ window.addEventListener("scroll",onScroll,{passive:true}); }
    window.__aliaLenis=lenis;   // so the mobile drawer can pause smooth scroll
    onScroll();

    if(hasGSAP && ST){
      gsap.registerPlugin(ST);
      if(window.SplitText){ try{ gsap.registerPlugin(SplitText); }catch(e){} }
      initReveals();
      initWayThere();
      initBilingual();
      initFireCanvas();
      initFooter();
    } else {
      // static fallbacks
      initWayThere();
      initBilingual();
      initFooter();
    }

    // anchor smooth scroll
    qsa('a[href^="#"]').forEach(function(a){
      a.addEventListener("click",function(e){
        var id=a.getAttribute("href"); if(id.length<2) return;
        var t=qs(id); if(!t) return; e.preventDefault();
        /* The nav is fixed, so it covers the top of whatever we land on. -10
           left the target's eyebrow under the bar; clear the SCROLLED nav
           height (62.5px — it is always scrolled by the time a jump lands)
           plus a little breathing room. The CSS scroll-margin-top on
           section[id] covers the non-Lenis and direct-hash paths. */
        if(lenis){ lenis.scrollTo(t,{offset:-76,duration:1.2}); }
        else { t.scrollIntoView({behavior:reduced?"auto":"smooth"}); }
      });
    });

    // refresh discipline
    var rt;
    window.addEventListener("resize",function(){ clearTimeout(rt); rt=setTimeout(function(){ if(hasGSAP&&ST) ST.refresh(); },220); });
    if(hasGSAP && ST){
      setTimeout(function(){ ST.refresh(); },300);
      window.addEventListener("load",function(){ ST.refresh(); });
      if(doc.fonts && doc.fonts.ready){ doc.fonts.ready.then(function(){ ST.refresh(); }); }
    }
  }

  root.classList.remove("nojs");
  body.classList.remove("nojs");
  if(doc.readyState==="loading"){ doc.addEventListener("DOMContentLoaded",function(){ runPreloader(boot); }); }
  else { runPreloader(boot); }
})();

/* ===== 2/3 · ALIA-DOCK-REVEAL: show the no-JS fallback dock only after the preloader ===== */
  (function(){
    function run(){
      var d=document.querySelector('.alia-cta-dock'); if(!d) return;
      function reveal(){ d.classList.add('revealed'); }
      /* Was a broad selector list that also matched #intro and .intro-grid —
         permanent sections, so `gone` never became true and the dock only
         appeared on the 6s ceiling. This theme's preloader is .pre and gets
         .done when it finishes; match what the widget already watches. */
      var SEL='.pre';
      var pre=document.querySelector(SEL);
      if(pre){
        var start=Date.now();
        var iv=setInterval(function(){
          var el=document.querySelector(SEL), gone=!el;
          if(el){ var cs=getComputedStyle(el); gone=(cs.display==='none'||cs.visibility==='hidden'||parseFloat(cs.opacity)<0.1); }
          if(gone || (Date.now()-start)>6000){ reveal(); clearInterval(iv); }
        },200);
      } else {
        if(document.readyState==='complete'){ setTimeout(reveal,700); }
        else { window.addEventListener('load',function(){ setTimeout(reveal,700); }); }
      }
    }
    if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run); } else { run(); }
  })();

/* ===== 3/3 · ALIA-DRAWER behaviour: mobile navigation drawer ===== */
(function(){
  var body=document.body;
  var burger=document.getElementById('navBurger');
  var drawer=document.getElementById('navDrawer');
  if(!burger||!drawer) return;

  /* Must track the CSS breakpoint that hides .nav-links (1200px, measured from
     content width). Left at the old 899 the drawer would stay open when the
     viewport crossed back to the desktop bar. */
  var MQ=window.matchMedia('(max-width:1199px)');
  var lastFocus=null;

  function focusables(){ return drawer.querySelectorAll('a[href],button:not([disabled])'); }
  function isOpen(){ return body.classList.contains('drawer-open'); }
  function lenis(fn){
    var l=window.__aliaLenis;
    if(l && typeof l[fn]==='function'){ try{ l[fn](); }catch(e){} }
  }

  function open(){
    lastFocus=document.activeElement;
    body.classList.add('drawer-open','locked');
    burger.setAttribute('aria-expanded','true');
    drawer.removeAttribute('aria-hidden');
    lenis('stop');
    var f=focusables(); if(f.length) f[0].focus();
  }

  function close(){
    body.classList.remove('drawer-open','locked');
    burger.setAttribute('aria-expanded','false');
    drawer.setAttribute('aria-hidden','true');
    lenis('start');
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }

  burger.addEventListener('click',function(){ isOpen()?close():open(); });

  /* Capture phase on purpose: this must unlock the page and restart Lenis BEFORE
     the theme's own a[href^="#"] smooth-scroll handler fires on the link itself,
     otherwise it would scroll while body.locked still pins the page at the top. */
  drawer.addEventListener('click',function(e){
    var t=e.target;
    if(t && t.closest && t.closest('a[href]')) close();
  },true);

  document.addEventListener('keydown',function(e){
    if(!isOpen()) return;
    if(e.key==='Escape'){ close(); return; }
    if(e.key!=='Tab') return;
    var f=focusables(); if(!f.length) return;
    var first=f[0], last=f[f.length-1];
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
  });

  /* never leave it open when the viewport crosses back to desktop */
  function onMQ(){ if(!MQ.matches && isOpen()) close(); }
  if(MQ.addEventListener) MQ.addEventListener('change',onMQ);
  else if(MQ.addListener) MQ.addListener(onMQ);

  /* The live doors readout that used to be mirrored into the drawer went with
     the countdown (§2) — element, reference and CSS removed together, per
     TRAP 14: leaving the querySelector behind throws and kills the script. */
})();

